// extracted by css-extract-rspack-plugin
var _1 = "filter-SDjFPd";
var _2 = "table-RiX3gU";
export { _1 as "filter", _2 as "table" }
